import { useEffect } from 'react';
import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { DirectionProvider } from '@components/ui/direction';
import { Toaster } from '@components/ui/sonner';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
});

function AppLayout() {
  useEffect(() => {
    const root = document.documentElement;
    const previousDir = root.getAttribute('dir');
    const previousLang = root.getAttribute('lang');
    root.setAttribute('dir', 'rtl');
    root.setAttribute('lang', 'he');
    return () => {
      if (previousDir) root.setAttribute('dir', previousDir);
      else root.removeAttribute('dir');
      if (previousLang) root.setAttribute('lang', previousLang);
    };
  }, []);

  return (
    <DirectionProvider dir="rtl">
      <div dir="rtl" className="flex min-h-screen flex-col bg-background text-foreground">
        <header className="no-print sticky top-0 z-30 border-b border-[hsl(var(--rule))] bg-[hsl(var(--surface-1))]">
          <div className="mx-auto flex h-[var(--header-h)] w-full max-w-[1180px] items-center justify-between gap-4 px-4 sm:px-6">
            <Link to="/" className="group flex min-w-0 items-center gap-3">
              <span
                aria-hidden="true"
                className="flex size-10 shrink-0 items-center justify-center rounded-md bg-primary font-[family-name:var(--font-heading)] text-sm font-bold text-primary-foreground"
              >
                תא
              </span>
              <span className="min-w-0">
                <span className="block truncate font-[family-name:var(--font-heading)] text-lg font-bold leading-tight text-foreground sm:text-xl">
                  הפקולטה להנדסה
                </span>
                <span className="block truncate text-[12px] text-muted-foreground">
                  אוניברסיטת תל אביב · טפסים דיגיטליים
                </span>
              </span>
            </Link>
          </div>
        </header>

        <main className="flex-1">
          <Outlet />
        </main>

        <footer className="no-print mt-auto border-t border-[hsl(var(--rule))] bg-[hsl(var(--surface-1))] py-8 text-center text-xs text-muted-foreground">
          <div className="mx-auto max-w-[1180px] px-4 sm:px-6">
            <p>
              הפקולטה להנדסה ע״ש איבי ואלדר פליישמן · אוניברסיטת תל אביב · שירות טפסים דיגיטליים
            </p>
            <p className="mt-1 text-[11px] text-muted-foreground">
              כל הזכויות שמורות © {new Date().getFullYear()}
            </p>
          </div>
        </footer>

        <Toaster position="top-center" dir="rtl" />
      </div>
    </DirectionProvider>
  );
}
